// Centralized configuration for DemandSupplyMatching
export const filterTemplate = [
  { field: "PDL Name", headerName: "PDL Name" },
  { field: "EDL Name", headerName: "EDL Name" },

  { field: "Market", headerName: "Market" },
  // { field: "Market Unit", headerName: "Market Unit" },
  { field: "Businessunit Desc", headerName: "Business Unit" },
    { field: "Geography", headerName: "Geography" },
  { field: "Skill Tower", headerName: "Skill Tower" },
  { field: "Requirment Month", headerName: "Requirment Month" },
  // { field: "SO Grade", headerName: "SO Grade" },
  
  { field: "Demand Status", headerName: "Demand Status" },
  //  { field: "Open SO Ageing Range", headerName: "Open SO Ageing Range" },
];

export const tableTemplate = [
  { field: "SO Id", headerName: "SO Id" },
  // { field: "SO Line Status", headerName: "SO Line Status" },
  { field: "SO Submission Date", headerName: "SO Submission Date" },
  { field: "Requirement Start Date", headerName: "Requirement Start Date" },

  { field: "Requirment Month", headerName: "Requirment Month" },

  { field: "Open SO Ageing", headerName: "Open SO Ageing" },



  { field: "Market", headerName: "Market" },
  { field: "Market Unit", headerName: "Market Unit" },
  { field: "Department", headerName: "Department" },
  { field: "EIPO", headerName: "EIPO" },
  { field: "Vertical", headerName: "Vertical" },
  { field: "Off Onsite", headerName: "Offshore Onsite" },
  { field: "Geography", headerName: "Geography" },
  { field: "City", headerName: "City" },
  { field: "SO Grade", headerName: "SO Grade" },

  { field: "Account Name", headerName: "Account Name" },  

  { field: "Skill Tower", headerName: "Skill Tower" },
  { field: "Modified Skill Group", headerName: "Modified Skill Group" },
  { field: "Technical Skills Required", headerName: "Technical Skills Required" },
  { field: "Demand Status", headerName: "Demand Status" },
  { field: "Demand Category", headerName: "Demand Category" },
  { field: "Included In Forecast", headerName: "Included In Forecast" },
  { field: "Fulfilment Plan", headerName: "Fulfilment Plan" },
  { field: "Supply Source", headerName: "Supply Source" },
  { field: "Employee Id", headerName: "Employee Id" },
  { field: "Employee Name", headerName: "Employee Name" },
  { field: "Grades", headerName: "Employee Grade" },

  { field: "Billability Start Date", headerName: "Billability Start Date" },
  { field: "SO Billability", headerName: "SO Billability" },
  { field: "Allocation Date", headerName: "Allocation Date" },
  { field: "Allocation Week", headerName: "Allocation Week" },
  { field: "Eff Month", headerName: "Eff Month" },
  { field: "Remarks Details", headerName: "Remarks Details" },
  { field: "Open SO Ageing Range", headerName: "Open SO Ageing Range" },
  { field: "Action", headerName: "Action" },
  { field: "Action Date", headerName: "Action Date" },
  { field: "Proposed Date", headerName: "Proposed Date" },
  { field: "Billing Start Date", headerName: "Proposed Billing Start Date" },
  { field: "SO Reserve Status", headerName: "SO Reserve Status" },
  { field: "Reserve End Date", headerName: "Reserve End Date" },
  // { field: "Skill Family", headerName: "Skill Family" },
  { field: "Project Id", headerName: "Project Id" },
  { field: "Project Name", headerName: "Project Name" },
  { field: "Project Type", headerName: "Project Type" },
  { field: "Project Billability Type", headerName: "Project Billability Type" },
  { field: "Demand Type", headerName: "Demand Type" },
  // { field: "Technical Skills Desired", headerName: "Technical Skills Desired" },
  { field: "Current Status", headerName: "Current Status" },
  // { field: "Fet Demand Status", headerName: "Fet Demand Status" },
  // { field: "Fet Remarks", headerName: "Fet Remarks" },
  // { field: "PDL", headerName: "PDL" },
  { field: "PDL Name", headerName: "PDL Name" },
  // { field: "EDL", headerName: "EDL" },
  { field: "EDL Name", headerName: "EDL Name" },
  { field: "Cross Skill Required", headerName: "Cross Skill Required" },
  { field: "Rotation SO", headerName: "Rotation SO" },
  { field: "Supply Account", headerName: "Supply Account" },
  { field: "Subpractice", headerName: "Subpractice" },
  { field: "Businessunit Desc", headerName: "Businessunit Desc" },
  { field: "Account Id", headerName: "Account Id" },
  { field: "Parent Customer Id", headerName: "Parent Customer Id" },
  // { field: "Quantity", headerName: "Quantity" },
  // { field: "Pe Flagged", headerName: "Pe Flagged" },
  { field: "Requirement End Date", headerName: "Requirement End Date" },
  { field: "Job Code", headerName: "Job Code" },
   { field: "Flagged For Recruitment", headerName: "Flagged For Hiring" },
  { field: "When Flagged For Recruitment", headerName: "When Flagged For Hiring" },
 
  { field: "Hiring Manager", headerName: "Hiring Manager" },
  { field: "Candidate Name", headerName: "Candidate Name" },
  { field: "Date Of Joining", headerName: "Date Of Joining" },
    { field: "Tmp Remarks", headerName: "Tmp Remarks" },
  
  { field: "Fulfillment Month", headerName: "Fulfillment Month" },
    { field: "Parent Customer", headerName: "Parent Customer" },
  { field: "item_id", headerName: "item_id" },
];

// Audit columns for audit modal (exported so page can use them)
export const auditColumns = [
  { field: "auditid", headerName: "Audit ID", width: 100 },
  { field: "so_id", headerName: "SO Id", width: 150 },
  { field: "status", headerName: "Status", width: 120 },
  { field: "demand_type", headerName: "Demand Type", width: 200 },
  { field: "demand_status", headerName: "Demand Status", width: 200 },
  { field: "identified_assoc_id_external_candidate_id", headerName: "Employee Id", width: 250 },
  { field: "identified_assoc_name", headerName: "Employee Name", width: 200 },
  { field: "grade", headerName: "Grade", width: 100 },
  { field: "joining_allocation_date", headerName: "Joining/Allocation Date", width: 180 },
  { field: "fulfilment_plan", headerName: "Fulfilment Plan", width: 200 },
  { field: "demand_category", headerName: "Demand Category", width: 200 },
  { field: "supply_source", headerName: "Supply Source", width: 200 },
  { field: "cross_skill_required_yes_no", headerName: "Cross Skill Required", width: 200 },
  { field: "rotation_so", headerName: "Rotation SO", width: 200 },
  { field: "supply_account", headerName: "Supply Account", width: 200 },
  { field: "allocation_week", headerName: "Allocation Week", width: 200 },
  { field: "eff_month", headerName: "Eff Month", width: 200 },
  { field: "included_in_forecast", headerName: "Included In Forecast", width: 200 },
  { field: "remarks_details", headerName: "Remarks Details", width: 200 },
  { field: "modified_date", headerName: "Modified Date", width: 180 },
  { field: "modified_by", headerName: "Modified By", width: 150 },
  { field: "modified_by_name", headerName: "Modified By Name", width: 150 },
  { field: "allocation_date", headerName: "Allocation Date", width: 150 },
  { field: "action", headerName: "Action", width: 150 },
  { field: "comments", headerName: "Comments", width: 200 },
  { field: "coe_confidence", headerName: "COE Confidence", width: 200 },
  { field: "fulfillment_action_plan", headerName: "Fulfilment Action Plan", width: 200 },
  { field: "proposed_allocation_date", headerName: "Proposed Allocation Date", width: 200 },
  { field: "proposed_billability_date", headerName: "Proposed Billability Date", width: 200 },
];

export const editableColumns = [
 

 { field: "Demand Type", headerName: "Demand Type" },
    { field: "Demand Category", headerName: "Demand Category" },
      { field: "Demand Status", headerName: "Demand Status" },
      { field: "Demand Validity", headerName: "Demand Validity" },
      
  { field: "Included In Forecast", headerName: "Included In Forecast" },

    { field: "Proposed Allocation Date", headerName: "Proposed Allocation Date", width: 150 },
      { field: "Proposed Billability Date", headerName: "Proposed Billability Date", width: 150 },

 { field: "Skill Tower", headerName: "Skill Tower" },

    { field: "COE Confidence", headerName: "COE Confidence" },

    

  { field: "Fulfilment Action Plan", headerName: "Fulfilment Action Plan" },

 { field: "Fulfilment Plan", headerName: "Fulfilment Plan" },


   { field: "Supply Source", headerName: "Supply Source" },
  { field: "Employee Id", headerName: "Employee Id" },
  { field: "Employee Name", headerName: "Employee Name" },
  { field: "Grades", headerName: "Emloyee Grade" },
 { field: "Action", headerName: "Action" },
    { field: "Action Date", headerName: "Action Date" },
  { field: "Remarks Details", headerName: "Remarks Details" },
 

 
  { field: "Allocation Date", headerName: "Allocation Date" },
  { field: "Billing Start Date", headerName: "Billing Start Date" },
  // { field: "Proposed Date", headerName: "Proposed Date" },

    { field: "SO Reserve Status", headerName: "SO Reserve Status" },
  { field: "Reserve End Date", headerName: "Reserve End Date" },

  

  { field: "Cross Skill Required", headerName: "Cross Skill Required" },

   { field: "HR Status", headerName: "HR Status" },
  { field: "Constraint", headerName: "Constraint" },
 { field: "SEF", headerName: "SEF" },
  { field: "Hacker Rank Score", headerName: "Hacker Rank Score" },



  // { field: "Supply Account", headerName: "Supply Account" },

];

export default {
  filterTemplate,
  tableTemplate,
  editableColumns,
};
